import { getSectionPaddingClass, getThemeClass, getTitleClass } from "~/styles/styles"
import Section from "../../common/section"
import Image from "next/image"

const OurSupplyChain = () => {
  const SUPPLY_CHAIN = [
    {
      title: "TEAM Inc",
      body: "As we aren’t a botanical garden, we don’t need expert horticulturalists to maintain our grounds at HQ. Instead, we enlist the help of Team Inc, who train, employ, mentor and accommodate people with disabilities, hiring their dedicated team to maintain our gardens, aligning with our commitment to helping people with disabilities and building sustainable supply chains Australia wide.",
      image: "/images/about-us/sustainability/Teams-Inc-social-enterprise.png",
    },
    {
      title: "who gives a crap",
      body: "With each wipe, our team members are helping to create a better world. By using Who Gives a Crap across our offices, we are contributing to building toilets and improving sanitation in the developing world.  ",
      image: "/images/about-us/sustainability/Who-gives-a-crap.png",
    },
    {
      title: "fruit2work",
      body: "Fruit2Work creates chances for people who have been impacted by the justice system by providing them transitional employment to help them rebuild their lives. This is the team who deliver our fruit.",
      image: "/images/about-us/sustainability/Fruit2Work.png",
    },
  ]

  return (
    <Section className={`${getThemeClass("light")} ${getSectionPaddingClass()}`}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className={`text-desk-resp-3xl text-purpleblue font-bold`}>Energising our supply chain</h2>
          <p className="text-desk-resp-xl mt-2">
            <span className="text-purpleblue">{`>6% `}</span>
            <span className="text-gray-950">{` of our non-inventory supply chain is sourced from `}</span>
            <span className="text-purpleblue">{`social enterprises `}</span>
            <span className="text-gray-950">{`just like these:`}</span>
          </p>
        </div>
        <div className="flex flex-col gap-12 md:gap-8 mt-12">
          {SUPPLY_CHAIN.map((item, i) => (
            <div key={i} className={`grid md:grid-cols-2 gap-x-8 items-center group overflow-hidden`}>
              <div className={`${i % 2 === 0 ? "md:order-last" : "md:order-first md:text-right"}`}>
                <p className={`text-purpleblue text-desk-resp-2xl font-bold`}>{item.title}</p>
                <p>{item.body}</p>
              </div>
              <Image src={item.image} alt={item.title} width={800} height={600} className="mt-4 md:mt-0 group-hover:opacity-90" />
            </div>
          ))}
        </div>
        <div className="mt-8 md:mt-12">
          <p className="text-desk-resp-2xl font-bold text-purpleblue text-center">We support many more impactful organisations just like these!</p>
        </div>
      </div>
    </Section>
  )
}

export default OurSupplyChain
